import { addCdnToUrl } from '../../../../../shared/assets'

export const getAvatarSource = (photo: string) => (photo.includes('http') ? photo : addCdnToUrl(`/assets/img/managers/${photo}`))
